// extracted by mini-css-extract-plugin
export default {"view":"ProductsUI_view__dxr2w","loader":"ProductsUI_loader__KagxX","description":"ProductsUI_description__1Vx+W","input":"ProductsUI_input__u9Xuj","menu":"ProductsUI_menu__-a0+q"};